module.exports = __webpack_public_path__ + "img/payment-method-safe.17d62d5a.svg";